// Morada padrão de entrega: armazéns LOGNOW (Amorim).
// Quase todas as encomendas vão para aqui — apenas raras exceções vão direto ao cliente.
export const LOGNOW_MORADA = {
  etiqueta: 'Armazéns LOGNOW (default)',
  nome: 'LOGNOW — Armazéns',
  nif: '',
  morada: 'Rua do Rio Novo 345B',
  cod_postal: '4495-195',
  pais: 'Portugal',
  telefone: '',
}

export const LOGNOW_MORADA_LABEL_LOCAL = 'Amorim'

// Slots de encomenda em transito por artigo.
//
// Eram tres. Passaram a cinco a 29/08/2026: a encomenda 0032/2026 nao teve
// onde por 31 unidades do Double Serum porque os tres estavam ocupados com
// datas diferentes. Ver supabase/sql/transitos_t4_t5.sql.
//
// Esta lista manda no que o ecra mostra, no que se le da base de dados e no
// que se grava. Acrescentar um sexto slot e acrescentar a coluna na base de
// dados e o numero aqui — mas tambem N_TRANSITOS nas edge functions que rodam
// os slots (sync-lognow-stock, verificar-transitos-atrasados,
// check-stock-alerts), que nao conseguem importar deste ficheiro.
export const SLOTS_TRANSITO = [1, 2, 3, 4, 5]
